import { React } from 'react';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const SubmitButton = ({ isSubmit, disabled, children, startIcon }) => {
    return (
        <Button
            type='submit'
            variant='contained'
            disabled={isSubmit || disabled}
            startIcon={startIcon}
            endIcon={isSubmit && <CircularProgress size={20} />}
        >
            {children}
        </Button>
    );
};

export default SubmitButton;
